import { render, staticRenderFns } from "./RecoveryPass.vue?vue&type=template&id=31233900"
import script from "./RecoveryPass.vue?vue&type=script&lang=js"
export * from "./RecoveryPass.vue?vue&type=script&lang=js"
import style0 from "./RecoveryPass.vue?vue&type=style&index=0&id=31233900&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31233900')) {
      api.createRecord('31233900', component.options)
    } else {
      api.reload('31233900', component.options)
    }
    module.hot.accept("./RecoveryPass.vue?vue&type=template&id=31233900", function () {
      api.rerender('31233900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RecoveryPass.vue"
export default component.exports